export default __webpack_public_path__ + "static/media/51-MineraSanta-Maria.2f34a81a.jpg";